const hasFieldFormikError = (errors, touched, name) =>
  name && errors && errors[name] && touched && touched[name]

export default hasFieldFormikError
